<template>
    <div v-if="infoTextShow && user" class="lead-info">
        <slot></slot>
        <i class="iconfont icon-checked"></i>
        <span class="text">{{ onSubmitOption.toastMsg }}</span>
    </div>

    <v-form
        v-else
        ref="form"
        class="info-form2"
        :onSubmit="registerSubmit"
        :onSuccess="registerSubmitSuccess"
        :onError="registerSumbitError"
    >
        <slot></slot>
        <div class="input-content">
            <div class="basic-info">
                <input-item
                    v-for="item in baiscInputs"
                    :key="item.name"
                    :item="item"
                    :className="['basic-info-input']"
                    :showTitle="showTitle"
                    :changeLabelPos="changeLabelPos"
                    :style="lenderStyle"
                ></input-item>
            </div>
            <v-input
                v-if="messageOption"
                class="message"
                name="question"
                tag="textarea"
                :placeholder="
                    showTitle
                        ? ''
                        : (messageOption.placeholder || $t('md-form.message')) +
                            (messageOption.required ? '*' : '')
                "
                :value="defaultMsg"
                :required="messageOption.required"
                :style="lenderStyle"
            >
                <p v-if="showTitle" class="title">
                    {{ messageOption.title }}
                    <span v-if="messageOption.required">*</span>
                </p>
                <template #footer>
                    <div v-if="submitPos === 'right'" class="submit-content">
                        <div class="submit-box">
                            <button
                                class="submit"
                                v-html="submitText || $t('md-form.submit')"
                                :disabled="submitDisabled"
                                :class="{ 'submit-disabled': submitDisabled }"
                                :style="submitStyle"
                            ></button>
                        </div>
                    </div>
                </template>
            </v-input>
        </div>
        <div
            v-if="
                submitPos === 'bottom' ||
                    (!messageOption && submitPos !== 'afterbottom')
            "
            class="submit-content"
        >
            <div class="submit-box">
                <button
                    v-if="submitText"
                    class="submit"
                    v-html="submitText || $t('md-form.submit')"
                    :disabled="submitDisabled"
                    :class="{ 'submit-disabled': submitDisabled }"
                    :style="submitStyle"
                ></button>
                <button
                    v-if="icon"
                    class="submit submit-icon"
                    :disabled="submitDisabled"
                    :class="{ 'submit-disabled': submitDisabled && icon}"
                >
                    <i
                        v-if="icon"
                        class="iconfont"
                        :class="icon"
                        :style="submitStyle"
                    ></i>
                </button>
            </div>
        </div>
        <template v-if="showDisclaimer">
            <teleport v-if="disclaimerTeleportId" :to="disclaimerTeleportId">
                <Disclaimer
                    :color="disclaimerColor"
                    :disclaimerUniqId="disclaimerUniqId"
                    @updateChecked="checked => (disclaimerChecked = checked)"
                    @disclaimerContainerMount="disclaimerContainerMount"
                    :btnText="icon ? '' : (submitText || $t('md-form.submit'))"
                />
            </teleport>
            <Disclaimer
                v-else
                :color="disclaimerColor"
                :disclaimerUniqId="disclaimerUniqId"
                @updateChecked="checked => (disclaimerChecked = checked)"
                @disclaimerContainerMount="disclaimerContainerMount"
                :btnText="icon ? '' : (submitText || $t('md-form.submit'))"
            />
        </template>
        <div v-if="submitPos === 'afterbottom'" class="submit-content">
            <div class="submit-box">
                <button
                    class="submit"
                    v-html="submitText || $t('md-form.submit')"
                    :disabled="submitDisabled"
                    :class="{ 'submit-disabled': submitDisabled }"
                    :style="submitStyle"
                ></button>
            </div>
        </div>
    </v-form>
</template>

<script>
import { mapState as rootMapState, mapActions as rootMapActions } from 'pinia';
import { usePageStore, useBuildingStore } from '@/store';
import util from '@/common/util';
import message from '../../mixins/message';
import inputItem from '../../components/input-item.vue';
import vForm from '../../components/v-form.vue';
import vInput from '../../components/v-input.vue';
import { openLoginHideOtherPop } from '@/components/sign-log';
import Disclaimer from '@/components/disclaimer';
import { getEmptyFormListObj } from '@/common/utils/form.js';
import { INTERCEPT_URL } from '@/common/customize';
import { leadTypes } from '@/common/const';
const addressArr = ['streetAddress', 'city', 'state', 'zipCode'];

const noteKeyMap = {
    meetTime: 'meeting time'
};
export default {
    emits: ['done'],
    i18next: {
        ns: 'md-form'
    },
    mixins: [message],
    props: {
        changeLabelPos: {
            type: Boolean,
            default: true
        },
        registerRole: {
            type: String,
            default: '2'
        },
        tag: {
            type: String,
            default: ''
        },
        questionnaire: {
            type: Object,
            default: () => ({})
        },
        formList: {
            type: Array,
            default: () => []
        },
        messageOutside: {
            type: Boolean,
            default: false
        },
        showTitle: {
            type: Boolean,
            default: false
        },
        showLender: {
            type: Boolean,
            default: true
        },
        lenderStyle: {
            type: Object,
            default: () => ({})
        },
        defaultMsg: {
            type: String,
            default: ''
        },
        submitText: {
            type: String,
            default: ''
        },
        icon: {
            type: String,
            default: ''
        },
        submitStyle: {
            type: Object,
            default: () => ({})
        },
        submitPos: {
            type: String,
            default: 'bottom'
        },
        infoTextShow: {
            type: Boolean,
            default: false
        },
        onSubmitOption: {
            type: Object,
            default: () => ({
                type: 'toast',
                toastMsg: 'Thanks! I\'ll get back to you shortly.',
                url: '/',
                toastDelay: 2000
            })
        },
        showDisclaimer: {
            type: Boolean,
            default: true
        },
        disclaimerColor: {
            type: String,
            default: ''
        },
        disclaimerTeleportId: {
            type: String,
            default: ''
        },
        registerLogin: {
            type: Boolean,
            default: false
        }
    },
    data: function() {
        return {
            submitLoading: false,
            disclaimerChecked: true,
            disclaimerUniqId: util.uuidv4()
        };
    },
    computed: {
        ...rootMapState(useBuildingStore, {
            buildingInfo: 'buildingInfo',
            listingDetailInfo: 'listingDetailInfo'
        }),
        ...rootMapState(usePageStore, {
            page: store => store.page
        }),
        submitDisabled() {
            return this.submitLoading || !this.disclaimerChecked;
        },
        role({ page }) {
            return this.registerRole || page.registerUserType || leadTypes.Buyer;
        },
        isBuildingDetail({ page }) {
            //  judge whether buildingDetail page
            return page.pageKey === 'building';
        },
        streetAddress() {
            //  default page display streetAddress， remove # Number
            if (
                this.listingDetailInfo?.chimeComplex &&
                this.listingDetailInfo.chimeComplex !== 'null'
            ) {
                return this.listingDetailInfo.chimeComplex;
            } else {
                const addr = this.listingDetailInfo?.streetAddress || '';
                const newAddr = addr.split('#')[0];
                return newAddr;
            }
        },
        noteKeyArr() {
            const noteKeyArr = [];
            for (let i = 0, len = this.formList.length; i < len; i++) {
                const name = this.formList[i].name;
                const nameArr = ['fullname', 'email', 'phone', 'question'];
                if (!nameArr.includes(name)) {
                    noteKeyArr.push(name);
                    noteKeyMap[name] = this.formList[i].title;
                }
            }
            return noteKeyArr;
        },
        resetObj() {
            return getEmptyFormListObj(
                this.formList,
                item => ['fullname', 'email', 'phone'].includes(item.name),
                {
                    address: {
                        streetAddress: '',
                        zipCode: '',
                        city: '',
                        state: '',
                        question: ''
                    }
                }
            );
        },
        baiscInputs({ page }) {
            const baiscInputs = [];
            for (let i = 0, len = this.formList.length; i < len; i++) {
                const formItem = this.formList[i];
                const name = formItem.name;
                let value = '';
                let type = 'text';
                let validateConfig = {};
                let maxlength = 50;
                let tag =
                    name === 'question' || formItem.type === 'Paragraph Text'
                        ? 'textarea'
                        : 'input';
                switch (name) {
                case 'fullname':
                    value = (this.user && this.user.fullName) || '';
                    maxlength = 30;
                    break;
                case 'email':
                    value = (this.user && this.user.account) || '';
                    type = 'email';
                    validateConfig = {
                        async: '/api-site/register/hasUser?account={value}',
                        'async-callback': this.hasUserCallBack
                    };
                    maxlength = 50;
                    break;
                case 'phone':
                    value = (this.user && this.user.phoneNumber) || '';
                    type = 'tel';
                    validateConfig = {
                        async: '/api-site/phoneValidate?phoneNumber={value}'
                    };
                    maxlength = 12;
                    break;
                case 'meetTime':
                    type = 'date';
                    maxlength = 10;
                    break;
                case 'address':
                    type = 'address';
                    break;
                default:
                    break;
                }
                if (name === 'question' && this.messageOutside) {
                    continue; 
                }
                if (name === 'fullname' && formItem.nameType === 2) {
                    baiscInputs.push({
                        readonly: this.user,
                        tag: 'input',
                        type,
                        name: 'firstName',
                        required: formItem.required,
                        value: (this.user && this.user.firstName) || '',
                        title:
                            formItem.firstNameTitle +
                            (formItem.required ? '<span>*</span>' : ''),
                        placeholder:
                            formItem.firstNameTitle +
                            (formItem.required ? '*' : ''),
                        maxlength
                    });
                    baiscInputs.push({
                        readonly: this.user,
                        tag: 'input',
                        type,
                        name: 'lastName',
                        required: formItem.required,
                        value: (this.user && this.user.lastName) || '',
                        title:
                            formItem.lastNameTitle +
                            (formItem.required ? '<span>*</span>' : ''),
                        placeholder:
                            formItem.lastNameTitle +
                            (formItem.required ? '*' : ''),
                        maxlength
                    });
                    continue;
                }
                if (name === 'address' && formItem.addressType === 2) {
                    baiscInputs.push({
                        readonly: false,
                        type: 'text',
                        name: 'streetAddress',
                        required: formItem.required,
                        value: '',
                        title:
                            this.$t('md-form.streetAddress') +
                            (formItem.required ? '<span>*</span>' : ''),
                        placeholder:
                            this.$t('md-form.streetAddress') +
                            (formItem.required ? '*' : ''),
                        maxlength: 50
                    });
                    baiscInputs.push({
                        readonly: false,
                        type: 'text',
                        name: 'city',
                        required: formItem.required,
                        value: '',
                        title:
                            this.$t('md-form.city') +
                            (formItem.required ? '<span>*</span>' : ''),
                        placeholder:
                            this.$t('md-form.city') +
                            (formItem.required ? '*' : ''),
                        maxlength: 50
                    });
                    baiscInputs.push({
                        readonly: false,
                        type: 'text',
                        name: 'state',
                        required: formItem.required,
                        value: '',
                        title:
                            (page.country === 'canada'
                                ? this.$t('md-form.province')
                                : this.$t('md-form.state')) +
                            (formItem.required ? '<span>*</span>' : ''),
                        placeholder:
                            (page.country === 'canada'
                                ? this.$t('md-form.province')
                                : this.$t('md-form.state')) +
                            (formItem.required ? '*' : ''),
                        maxlength: 50
                    });
                    baiscInputs.push({
                        readonly: false,
                        type: 'text',
                        name: 'zipCode',
                        required: formItem.required,
                        value: '',
                        title:
                            (page.country === 'canada'
                                ? this.$t('md-form.postalCode')
                                : this.$t('md-form.zipCode')) +
                            (formItem.required ? '<span>*</span>' : ''),
                        placeholder:
                            (page.country === 'canada'
                                ? this.$t('md-form.postalCode')
                                : this.$t('md-form.zipCode')) +
                            (formItem.required ? '*' : ''),
                        maxlength: page.country === 'canada' ? 7 : 10,
                        validateConfig: {
                            pattern:
                                page.country === 'canada'
                                    ? '^[a-zA-Z]\\d[a-zA-Z]\\s?\\d[a-zA-Z]\\d'
                                    : '^((\\d{5})|(\\d{5}[-]\\d{4})|(\\d{5}\\s\\d{4}))$',
                            'pattern-msg':
                                page.country === 'canada'
                                    ? this.$t('md-form.yourPostalCodeIsInvalid')
                                    : this.$t('md-form.yourZipCodeIsInvalid')
                        }
                    });
                } else {
                    let placeholder = '';
                    if (formItem.placeholder !== undefined) {
                        placeholder = formItem.placeholder;
                    } else {
                        placeholder =
                            name === 'fullname'
                                ? formItem.fullTitle || formItem.title
                                : formItem.title;
                    }
                    if (!this.showTitle) {
                        placeholder =
                            placeholder + (formItem.required ? '*' : '');
                    }
                    value = value || formItem.readValue || ''; //for custom made
                    Object.keys(validateConfig).length == 0 &&
                        Object.assign(validateConfig, formItem.validateConfig); //for custom made
                    baiscInputs.push({
                        readonly: !!value,
                        tag: tag,
                        type,
                        name,
                        required: formItem.required,
                        value,
                        title:
                            (name === 'fullname'
                                ? formItem.fullTitle || formItem.title
                                : formItem.title) +
                            (formItem.required ? '<span>*</span>' : ''),
                        placeholder: placeholder,
                        maxlength,
                        validateConfig,
                        defaultValue: name === 'question' ? this.defaultMsg : ''
                    });
                }
            }
            return baiscInputs;
        },
        messageOption() {
            if (this.messageOutside) {
                for (let i = 0, len = this.formList.length; i < len; i++) {
                    const formItem = this.formList[i];
                    if (formItem.name === 'question') {
                        let obj = {
                            title: formItem.title,
                            placeholder:
                                formItem.placeholder !== undefined
                                    ? formItem.placeholder
                                    : formItem.title,
                            required: formItem.required
                        };
                        if (this.isBuildingDetail) {
                            const { buildingName, buildingAddress } =
                                this.buildingInfo || {};
                            const name =
                                buildingName ||
                                buildingAddress ||
                                this.streetAddress ||
                                'this listing';
                            obj.placeholder =
                                'I am interested in ' + name + '.';
                        }
                        return obj;
                    }
                }
                return null;
            } else {
                return null;
            }
        }
    },
    methods: {
        ...rootMapActions(usePageStore, ['setCurrentUniqId']),
        registerSubmitSuccess(data = {}, isAutoRegister) {
            if (!isAutoRegister) {
                this.submitLoading = true;
                setTimeout(() => {
                    this.submitLoading = false;
                }, 3000);
            }
            this.tag && (data.tag = this.tag); //tag value -->formatData-->leaveMessage
            this.formatData(data); // The function is in mixins/register.js
            let note = '';
            let address = '';
            for (let i = 0, len = addressArr.length; i < len; i++) {
                const addressKey = addressArr[i];
                if (data[addressKey]) {
                    address = address
                        ? address + ',' + data[addressKey]
                        : data[addressKey];
                }
            }
            address && (data.address = address);
            let noteTitle = '';
            if (this.noteKeyArr.length) {
                if (data.firstName) {
                    noteTitle = this.$t('md-form.submittedAForm', {
                        name: data.firstName
                    });
                } else {
                    noteTitle = this.$t('md-form.submittedAForm', {
                        name: data.email.replace(/@.+/, '')
                    });
                }
            }
            for (let i = 0, len = this.noteKeyArr.length; i < len; i++) {
                const noteKey = this.noteKeyArr[i];
                if (data[noteKey]) {
                    note = note
                        ? note +
                          '\n' +
                          `${noteKeyMap[noteKey] || noteKey}: ` +
                          data[noteKey]
                        : `${noteKeyMap[noteKey] || noteKey}: ` + data[noteKey];
                }
            }
            if (note) {
                note = noteTitle + '\n' + note;
            }
            data.note = note;
            if (this.user && !isAutoRegister) {
                this.leaveMessage(this.onSuccessCallback); // The function is in mixins/message.js
            } else {
                this.setCurrentUniqId(
                    INTERCEPT_URL.leadRegister,
                    this.disclaimerUniqId
                );
                isAutoRegister
                    ? this.submitRegisterInfo(null, true)
                    : this.leadRegister();
            }
        },
        //  Call the background automatic registration timing
        leadAutoRegister(data) {
            this.registerSubmitSuccess(data, true);
        },
        registerNext(data) {
            console.log('registerNext', data)
            if (this.inquiry) {
                this.showQuestionnaire(
                    Object.assign({}, this.questionnaire || {}, {
                        noToast: true,
                        closeCallback: () => {
                            this.onSuccessCallback(data);
                        }
                    })
                );
            } else {
                this.onSuccessCallback(data);
            }
        },
        onSuccessCallback(data) {
            this.$emit('done');
            if (this.registerLogin || data.isRegisterAgentLead) {
                return this.$refs.form?.clear();
            }
            this.$refs.form?.reset(this.resetObj);
        },
        hasUserCallBack(flag, error, value) {
            if (
                !flag && error?.code === 210003
            ) {
                setTimeout(() => {
                    openLoginHideOtherPop({}, value);
                }, 1000);
            }
        },
        disclaimerContainerMount(domHeight) {
            this.$emit('disclaimerContainerMount', domHeight)
        }
    },
    components: {
        inputItem,
        vForm,
        vInput,
        Disclaimer
    }
};
</script>
<style lang="scss">
@import '../../theme/mixin.scss';

.info-form2 {
    .submit-content {
        .submit-box {
            display: inline-block;
            position: relative;
            .submit {
                background-color: var(--g-btn-background);
                border-color: var(--g-btn-background);
                color: var(--g-btn-color);
            }
            &:hover {
                &::after {
                    content: '';
                    background: rgba(25, 25, 25, 0.1);
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    pointer-events: none;
                }
            }
        }
        .submit[disabled].submit-disabled {
            cursor: not-allowed;
            @include input-disabled();
        }
    }

    .v-input .input-container {
        input,
        textarea {
            color: var(--g-primary-color);
            border-color: var(--input-border-color, var(--color-border));
            &::placeholder {
                color: var(--g-tip-color);
            }
        }
    }
}
</style>
